import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function WebsiteDevelopment() {
    return (

        <div className="inner-page about contact-page servi-ce-details">

            <Header />


            <div className="rts-breadcrumb-area bg_image">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="baread-crumb-main-wrapper pt--100">
                                <div className="inner">
                                    <h1 className="title rts_hero__title">SEO</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="service-details-area rts-section-gapTop bg-dark-s">
                <div className="container-150">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="main-page-title-service-left-area">
                                <div className="left">
                                    <h1 className="title-page rts_hero__title">
                                        Reach Your Target with Warmonks<br /> SEO Expertise
                                    </h1>
                                    <div className="bottom-content">
                                        <p className="disc">
                                            Warmonks specializes in developing and implementing SEO strategies to bring your website up in ranks, drive organic traffic, and enhance<br /> search engine rankings. The age of digitization has now become an inevitable factor where you can't remain unnoticed on the Google search.<br /> We can make your brand visible and reach out to the relevant audience in the vast online competition.</p>                                        {/* <div className="check-area-main-sd">
                                            <div className="single-check">
                                                <i className="fa-light fa-check"></i>
                                                <p>Content & Software Engineering</p>
                                            </div>
                                            <div className="single-check">
                                                <i className="fa-light fa-check"></i>
                                                <p>Artificial Intelligence and Learning New</p>
                                            </div>
                                            <div className="single-check">
                                                <i className="fa-light fa-check"></i>
                                                <p>Digital Service Platform</p>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="right">
                                    <div className="top-center-image circle-speen rts-scroll-down-circle-wrapper-3">
                                        <a href="#" className="speen-shape scroll-down-circle-3">
                                            <svg className="uni-circle-text-path uk-text-secondary uni-animation-spin"
                                                viewBox="0 0 100 100" width="180" height="180">
                                                <defs>
                                                    <path id="circle"
                                                        d="M 50, 50 m -37, 0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0" />

                                                </defs>
                                                <text font-size="11.75">
                                                    <textPath xlinkHref="#circle">Project SHowcase • Project SHowcase •
                                                    </textPath>
                                                </text>
                                            </svg>
                                            <i className="fa-solid fa-star-sharp"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row pt--80 pt_md--10 pt_sm--0">
                        <div className="col-xl-9 col-lg-12 pr--60 pr_md--15 pr_sm--10 pb_sm--30">

                            <div className="service-details-left">
                                <div className="thumbnaiul-large">
                                    <img src="assets/images/service/04.jpg" alt="service-details" />
                                </div>
                            </div>

                            <div className="single-para-title-service-details mt--40">
                                <h3 className="title">Our SEO Services</h3>
                                {<div className="check-area-main-sd">
                                    <div className="single-check">
                                        <i className="fa-light fa-check"></i>
                                        <p>On-Page SEO  We enhance the content, metadata, images, and structure of your website to make it more relevant and search engine friendly.  </p>
                                    </div>
                                    <div className="single-check">
                                        <i className="fa-light fa-check"></i>
                                        <p>Off-Page SEO:  Build up your domain authority and online reputation with quality backlinks, social signals, and strategic outreach efforts.  </p>
                                    </div>
                                    <div className="single-check">
                                        <i className="fa-light fa-check"></i>
                                        <p>Technical SEO:  Get your website search engine ready with enhanced site speed, mobile-friendliness, crawlability, and error resolution.</p>
                                    </div>
                                    <div className="single-check">
                                        <i className="fa-light fa-check"></i>
                                        <p>Local SEO: Helps you to appear more prominent on local searches, making it easy for customers to find and contact your business locally.</p>
                                    </div>
                                    <div className="single-check">
                                        <i className="fa-light fa-check"></i>
                                        <p>SEO Audit and Strategy: We execute a detailed SEO audit to identify areas of improvement as well as opportunities to lay down actionable strategies to improve performance.</p>
                                    </div>
                                </div>}                          </div>

                            <div className="single-para-title-service-details mt--40">
                                <h3 className="title">Warmonks - The Best SEO Company in Kerala  </h3>
                                <p className="disc">
                                    We focuses more on delivering results to ensure businesses succeed online. Our SEO practice is an unbeatable blend of proven experience with innovative methods to ensure your site is viewed and appreciated by relevant audiences. Branding, at Warmonks, allows businesses to hit and maintain the most coveted position- top rank-on search engine and gain increased exposure online. Help Unleash The Full Potential for Your Business- With real business impact in Search Engine Optimization End.</p>                                </div>

                            {/* <div className="image-thumbnail-2-service-d mt--50">
                                <div className="row g-4">
                                    <div className="col-lg-5">
                                        <div className="thumbnail-service">
                                            <img src="assets/images/service/05.jpg" alt="service" />
                                        </div>
                                    </div>
                                    <div className="col-lg-7">
                                        <div className="thumbnail-service">
                                            <img src="assets/images/service/06.jpg" alt="service" />
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                            <div className="faq-section-start-left-img mt--80">
                                <div className="row">
                                    <div className="col-xl-6 col-lg-12">
                                        <div className="thumbnail">
                                            <img src="assets/images/service/07.png" alt="service_images" />
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-lg-12 pl--50 pl_lg--0">

                                        <div className="service-details-accordion-area">
                                            <h3 className="title">Why choose Warmonks for SEO?</h3>
                                            <div className="accordion" id="accordionExample">
                                                <div className="accordion-item">
                                                    <h2 className="accordion-header" id="headingOne">
                                                        <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                                            data-bs-target="#collapseOne" aria-expanded="true"
                                                            aria-controls="collapseOne">
                                                            Proven Expertise
                                                        </button>
                                                    </h2>
                                                    <div id="collapseOne" className="accordion-collapse collapse show"
                                                        aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                                        <div className="accordion-body">
                                                            <p>Years of experience and a portfolio of successful projects make us the experts who can improve your search engine performance.  </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="accordion-item">
                                                    <h2 className="accordion-header" id="headingTwo">
                                                        <button className="accordion-button collapsed" type="button"
                                                            data-bs-toggle="collapse" data-bs-target="#collapseTwo"
                                                            aria-expanded="false" aria-controls="collapseTwo">
                                                            Customized Strategies
                                                        </button>
                                                    </h2>
                                                    <div id="collapseTwo" className="accordion-collapse collapse"
                                                        aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                                        <div className="accordion-body">
                                                            <p>Every business is unique, and so are our SEO solutions. We tailor our strategies to align with your goals, industry, and audience.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="accordion-item">
                                                    <h2 className="accordion-header" id="headingThree">
                                                        <button className="accordion-button collapsed" type="button"
                                                            data-bs-toggle="collapse" data-bs-target="#collapseThree"
                                                            aria-expanded="false" aria-controls="collapseThree">
                                                            Full-Service
                                                        </button>
                                                    </h2>
                                                    <div id="collapseThree" className="accordion-collapse collapse"
                                                        aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                                        <div className="accordion-body">
                                                            <p>From technical SEO audits to on-page optimization and link-building, we provide an end-to-end SEO service, covering all that you need to get done. </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="accordion-item">
                                                    <h2 className="accordion-header" id="headingFour">
                                                        <button className="accordion-button collapsed" type="button"
                                                            data-bs-toggle="collapse" data-bs-target="#collapseFour"
                                                            aria-expanded="false" aria-controls="collapseFour">
                                                            Analytics-Driven Insight
                                                        </button>
                                                    </h2>
                                                    <div id="collapseFour" className="accordion-collapse collapse"
                                                        aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                                                        <div className="accordion-body">
                                                            <p>Our approach is supported by deep analytics and insights to bring measurable and sustainable results. </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-12 mt_lg--50 rts-sticky-column-item">
                            <div className="theiaStickySidebar">
                                <div className="rts-single-wized Categories">
                                    <div className="wized-header">
                                        <h5 className="title">
                                            All Services
                                        </h5>
                                    </div>
                                    <div className="wized-body">

                                        <ul className="single-categories">
                                            <li><a href="/websitedevelopment">Website Development <i className="far fa-long-arrow-right"></i></a></li>
                                        </ul>

                                        <ul className="single-categories">
                                            <li><a href="/appdevelopment">App Development<i className="far fa-long-arrow-right"></i></a>
                                            </li>
                                        </ul>

                                        <ul className="single-categories">
                                            <li><a href="/ecommercedevelopment">Ecommerce Development<i className="far fa-long-arrow-right"></i></a>
                                            </li>
                                        </ul>

                                        <ul className="single-categories">
                                            <li><a href="/digitalmarketing">Digital Marketing<i className="far fa-long-arrow-right"></i></a></li>
                                        </ul>

                                        <ul className="single-categories">
                                            <li><a href="/seo">SEO<i className="far fa-long-arrow-right"></i></a></li>
                                        </ul>

                                        <ul className="single-categories">
                                            <li><a href="/graphicsdesigning">Graphic Designing <i className="far fa-long-arrow-right"></i></a></li>
                                        </ul>

                                    </div>
                                </div>
                                {/* <div className="rts-single-wized Categories">
                                    <div className="wized-header">
                                        <h5 className="title">
                                            Let's start new project.
                                        </h5>
                                    </div>
                                    <div className="wized-body">
                                        <form className="service-details-form" action="#">
                                            <input type="text" placeholder="Your name" />
                                            <input type="text" placeholder="Phone number" />
                                            <textarea placeholder="Message"></textarea>
                                            <button>Start Project</button>
                                        </form>
                                    </div>
                                </div> */}

                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <Footer />

            <div className="loading-screen" id="loading-screen">
                <span className="bar top-bar"></span>
                <span className="bar down-bar"></span>
                <span className="progress-line"></span>
                <span className="loading-counter"> </span>
            </div>


            <div className="bg-noise"></div>



            <div className="progress-wrap">
                <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
                    <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"></path>
                </svg>
            </div>

            <div className="rts-cursor cursor-outer" data-default="yes" data-link="yes" data-slider="no">
                <span className="fn-cursor"></span>
            </div>
            <div className="rts-cursor cursor-inner" data-default="yes" data-link="yes" data-slider="no">
                <span className="fn-cursor">
                    <span className="fn-left"></span>
                    <span className="fn-right"></span>
                </span>
            </div>

            <div className="modal-sidebar-scroll rts-dark-light">
                <ul>
                    <li className="go-dark-w"><span>Dark</span><i className="rts-go-dark fal fa-moon"></i></li>
                    <li className="go-light-w"><span>Light</span><i className="rts-go-light fa-light fa-brightness"></i></li>
                </ul>
            </div>


        </div>
    )
}

export default WebsiteDevelopment
